export default "__VITE_ASSET__B89mxWl8__"